export const PENDING    = '/PENDING'
export const SUCCESS    = '/SUCCESS'
export const FAILURE    = '/FAILURE'



// WEBPACK FOOTER //
// ./src/feedback/actionStatuses.js